import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as modalActions from 'actions/modalActions'
import store from '../../../store'
import { selectCalculatedTimers } from 'selectors/timerSelectors'
import TimerContext from './TimerContext'
import Timer from './Timer.jsx'

const timerContext = {
  view: 'modal'
}

export const TimersModalContent = React.memo(props => {
  const instances = useSelector(selectCalculatedTimers)

  // Decide which timers to display based on the clinic location
  const filteredInstances =
    props.clinicLocation != -1
      ? instances.filter(timer => timer.clinic_id == props.clinicLocation)
      : instances



  // NOTE: this will be a problem if a timer-less dialog is ever necessary
  useEffect(() => {
    if (filteredInstances.length === 0) {
      // i'm no longer needed!
      props.closeSelf()
    }
  }, [instances])

  return (
    <div className="timer-modal">
      <div className="timer-modal-title">All Timers</div>
      <div className="timer-modal-grid">
        <TimerContext.Provider value={timerContext}>
          {filteredInstances.map(timer => (
            <Timer
              key={timer.timer_id}
              timerId={timer.timer_id}
              context="modal"
              clinicLocation={props.clinicLocation}
            />
          ))}
        </TimerContext.Provider>
      </div>
    </div>
  )
})

export const openTimersModal = ({ clinicLocation }) => {
  const action = modalActions.openModal('timers', {
    title: 'Timers',
    content: <TimersModalContent clinicLocation={clinicLocation} />,
    closeable: true,
    preventDefaultMouseDown: true,
    containerClassName: 'timers-modal-container'
  })
  store.dispatch(action)
}
